import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the datatable for withdrawal requests.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user ID from parameters
        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Date', header: _('Fecha'), width: 100, sort: 'int' }, // Date column
                { id: 'User', header: _('Usuario'), width: 100, sort: 'int' }, // User column
                {
                    id: 'State',
                    header: _('Estado'),
                    editor: 'combo', // Combo editor for state
                    options: [
                        // State options
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 150,
                    sort: 'int',
                },
                { id: 'Token', header: _('Código'), width: 100, sort: 'int' }, // Token column
            ],
            editable: true, // Enable editing
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            // API URL for fetching data
            url: devConfig.geturlApi() + '/UserManagement/GetUserSecurityL?FromId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the grid and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Current user ID
        var url = grid.data.url; // Data URL for the grid
        this.on(this.app, 'generateTokenAgentList:filter', (filterData) => {
            // Event for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'FromDateLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'ToDateLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        grid.attachEvent('onBeforeEditStart', function (id) {
            // Event before editing starts
            var item = this.getItem(id); // Get item being edited
            console.log(item);
            if (id.column == 'State') {
                // Check if editing the State column
                var options = this.getColumnConfig('Action').collection; // Get action options
                if (item.State == 'A') {
                    // If state is 'Activado'
                    options.remove('A'); // Remove 'Activado' option
                } else if (item.State == 'I') {
                    // If state is 'Inactivado'
                    options.remove('I'); // Remove 'Inactivado' option
                } else {
                    return false; // Prevent editing if state is neither
                }
                console.log(id);
            }
        });
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            // Event after editing stops
            console.log(state);
            var item = this.getItem(editor.row); // Get edited item
            console.log(item);
            if (state.value != state.old) {
                // Check if value has changed
                if (state.value == 'A') {
                    // If new state is 'Activado'
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                            '{ "Id":' + item.Id + '}', // Send item ID
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'P'; // Update item state to 'Pending'
                                    webix.message('Cell value was changed'); // Show success message
                                },
                            },
                        );
                }
                if (state.value == 'P') {
                    // If new state is 'Pending'
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/PayWithdrawalRequests',
                            '{ "Id":' + item.Id + '}', // Send item ID
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'I'; // Update item state to 'Inactivado'
                                    webix.message('Cell value was changed'); // Show success message
                                },
                            },
                        );
                }
                if (state.value == 'E') {
                    // If new state is 'Eliminado'
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json', // Set content type
                        })
                        .post(
                            devConfig.geturlApi() + 'Client/CancelClientRequests',
                            '{ "Id":' + item.Id + '}', // Send item ID
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message('Error! '); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    item.State = 'E'; // Update item state to 'Eliminado'
                                    webix.message('Cell value was changed'); // Show success message
                                },
                            },
                        );
                }
            }
        });
        this.on(this.app, 'player:select', (id) => {
            // Event for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id, // Load grid data based on selected player ID
            );
        });
    }
}

// FILE DOCUMENTED
